export const css = {
	root: 'T11FN7_0',
	input: '_1NHJlQNp',
	inputWrapper: '_3OmERPuW _1wgpuhm9 _4h37s8L3',
	checked: 'PVZadxPQ',
	focused: '_3aDso-BJ',
	onLabel: '_3Kf3hSQh',
	offLabel: '_1hRwgwx5',
	disabled: '_2mQczIlp',
	readonly: '_3pq4xE2z',
	invalid: '_1sZNb7me',
	valid: '_2rQiQn5C',
	' _key': 'certwise-theme/certwise/dojo/checkbox'
};

export default css;
